import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { User } from '@barracuda/shared';
import { Language } from '@barracuda/shared/interface/language.interface';
import { ResultsSurveyVariant } from '../components/ResultsSurvey/ResultsSurvey';
import { PurchaseBlockedType } from '@/components/PurchaseBlockedPopup/PurchaseBlockedPopup';

export const AppContext = createContext<{
  isLoggedIn?: boolean;
  setIsLoggedIn?: any;
  user?: User;
  setUser?: any;
  openErrorSnackbar?: (message?: string) => void;
  emailPreviewData?: {
    company?: string;
    email?: string;
  };
  setEmailPreviewData?: any;
  testTaken?: boolean;
  setTestTaken?: any;
  eCommerceCountryISO2?: string;
  setECommerceCountryISO2?: any;
  language?: Language;
  setLanguage?: Dispatch<SetStateAction<Language>>;
  availableTests?: number;
  setAvailableTests?: Dispatch<SetStateAction<number>>;
  resultsSurveyOpen?: boolean;
  setResultsSurveyOpen?: Dispatch<SetStateAction<boolean>>;
  resultsSurveyVariant?: string;
  setResultsSurveyVariant?: Dispatch<SetStateAction<ResultsSurveyVariant | undefined>>;
  resultsSurveyLicenseId?: string;
  setResultsSurveyLicenseId?: Dispatch<SetStateAction<string | undefined>>;
  ipCountry?: string;
  mobileTestNotSupportedPopupOpened?: boolean;
  setMobileTestNotSupportedPopupOpened?: (state: boolean) => void;
  purchaseBlockedOpen?: boolean;
  setPurchaseBlockedOpen?: (state: boolean) => void;
  purchaseBlockedReason?: 'location' | 'vpn' | 'parentalConsent' | '';
  setPurchaseBlockedReason?: Dispatch<SetStateAction<PurchaseBlockedType>>;
  appNotInstalledPopupOpened?: boolean;
  setAppNotInstalledPopupOpened?: (state: boolean) => void;
}>({});

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('useAppContext must be used within an AppContext provider');
  }

  return context;
};
